<template>
    <ion-row v-if="!isLoyaltyMember && !hasOrderHistory" class="ion-justify-content-start rewards-content-block">
        <ion-col size="12" class="ion-align-items-center ion-justify-content-center ion-text-center">
            <contentBlock slug="home-page-nonmember-banner" />
        </ion-col>
    </ion-row>

    <ion-row v-else class="container ion-align-items-center ion-justify-content-start pr-8" style="margin-top: -1px">
        <!-- column 1 -->
        <ion-col v-if="isLoyaltyMember && hasOrderHistory" :size="4" class="ion-align-items-center ion-text-center">
            <ion-img alt="Donatos Rewards Logo" :src="require('@/assets/donatos-rewards-logo-dark.svg')" style="max-width: 250px; margin: auto" />
            <ion-text class="account-info-text welcome-header">Welcome{{ account.firstName ? `, ${account.firstName}` : '' }}!</ion-text>
            <br />
            <ion-text v-if="isLoyaltyProcessing" class="account-info-text interstate-bold large" style="display: inline-flex">
                You have <ion-spinner color="primary" name="lines-small" /> points.</ion-text
            >
            <ion-text v-else class="account-info-text interstate-bold large">You have {{ pointsValue }} points.</ion-text>
            <ion-row class="ion-justify-content-center rewards-content-block">
                <contentBlock slug="home-page-rewards-banner" />
            </ion-row>
        </ion-col>

        <ion-col v-else-if="isLoyaltyMember && !hasOrderHistory" :size="3" class="ion-align-items-center ion-text-center">
            <ion-img alt="Donatos Rewards Logo" :src="require('@/assets/donatos-rewards-logo-dark.svg')" style="max-width: 250px; margin: auto" />
        </ion-col>

        <ion-col v-else-if="!isLoyaltyMember && hasOrderHistory" :size="4" class="ion-align-items-center ion-text-center">
            <ion-row class="ion-justify-content-center rewards-content-block">
                <contentBlock slug="home-page-nonmember-banner" />
            </ion-row>
        </ion-col>

        <!-- column 2 -->
        <ion-col v-if="isLoggedIn && hasOrderHistory" size-sm="6" class="ion-align-items-center ion-text-left pl-16" :class="`orders-${orderHistoryCount}`">
            <ScrollOrderHistory />
        </ion-col>
        <ion-col v-if="isLoggedIn && isLoyaltyMember && !hasOrderHistory" size-sm="6" class="ion-align-items-center ion-text-center pl-16">
            <ion-text class="account-info-text welcome-header">Welcome{{ account.firstName ? `, ${account.firstName}` : '' }}!</ion-text>

            <ion-text v-if="isLoyaltyProcessing" class="account-info-text interstate-bold large" style="display: inline-flex">
                You have <ion-spinner color="primary" name="lines-small" /> points.</ion-text
            >
            <ion-text v-else class="account-info-text interstate-bold large"> You have {{ pointsValue }} points.</ion-text>
        </ion-col>

        <!-- column 3 (optional) -->
        <ion-col v-if="hasOrderHistory" size="2" class="ion-align-items-center ion-text-left pl-16 interstate-bold">
            <a @click="router.push({ path: '/history', name: 'history', params: { infoType: 'order' } })" color="primary">ALL RECENT ORDERS</a>
        </ion-col>
        <ion-col v-if="isLoggedIn && isLoyaltyMember && !hasOrderHistory" size="3">
            <ion-row class="ion-justify-content-center rewards-content-block">
                <contentBlock slug="home-page-rewards-banner" />
            </ion-row>
        </ion-col>
    </ion-row>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue';
import { IonRow, IonCol, IonImg, IonText, IonSpinner } from '@ionic/vue';
import { useStore } from 'vuex';
import contentBlock from '@/components/contentBlock.vue';
import ScrollOrderHistory from '@/components/scrollOrderHistory.vue';
import { Account } from '@/models/account/authModels';
import { useRouter } from 'vue-router';
import useShowRewards from '@/composables/useShowRewards';

export default defineComponent({
    components: { contentBlock, IonRow, IonCol, IonImg, IonText, ScrollOrderHistory, IonSpinner },
    setup() {
        const store = useStore();
        const router = useRouter();
        const { isLoyaltyMember } = useShowRewards();
        const account = computed((): Account => store.getters.getAccount);
        const pointsValue = computed(() => (account.value ? account.value.rewardSummary?.balance : ''));
        const isLoggedIn = computed(() => store.getters.isLoggedIn);

        const isLoyaltyProcessing = computed(() => store.getters.isLoyaltyProcessing);

        const hasOrderHistory = computed(() => store.getters.getHasOrderHistory);
        const orderHistoryCount = computed(() => store.getters.getOrderHistoryCount);

        return { pointsValue, isLoggedIn, hasOrderHistory, orderHistoryCount, account, isLoyaltyMember, router, isLoyaltyProcessing };
    },
});
</script>

<style scoped>
.container {
    color: var(--ion-color-light-contrast);
    background-color: #f0efed;
    padding: 20px;
}

.rewards-content-block {
    font-size: calc(14px + 0.2em);
}
.welcome-header {
    font-family: din-2014;
    font-weight: bold;
    font-size: 2em;
}
.account-info-text {
    color: var(--ion-color-primary);
    text-align: center;
    padding-bottom: 8px;
}

ion-col.orders-1 {
    max-width: 350px !important;
}
ion-col.orders-2 {
    max-width: 700px !important;
}
ion-col.orders-3 {
    max-width: 1000px !important;
}
</style>
